<template>
  <div class="row">
    <div class="col-12 mb-3">
      <button
        v-if="searchTerm"
        type="button"
        class="badge badge-pill badge-primary border-primary bg-white text-primary btn-outline-primary mr-2 py-2 px-3 mb-2"
        style="font-size: 0.8rem"
        :aria-label="content.removeSearchTermFilter"
        @click="onSearchTermClick"
      >
        Search: {{ searchTerm }}
        <span aria-hidden="true" class="ml-1">
          <FontAwesomeIcon :icon="icons.faTimes" />
        </span>
      </button>
      <template v-for="group in appliedFilterGroups">
        <button
          v-for="filter in group.facets"
          :key="filter.value"
          type="button"
          class="badge badge-pill badge-primary border-primary bg-white text-primary btn-outline-primary mr-2 py-2 px-3 mb-2"
          style="font-size: 0.8rem"
          :aria-label="content.removeFilter"
          @click="onFilterClick(group.value, filter.value)"
        >
          {{ group.name }}: {{ filter.name }}
          <span aria-hidden="true" class="ml-1">
            <FontAwesomeIcon :icon="icons.faTimes" />
          </span>
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { createNamespacedHelpers } from 'vuex';

import { mutation, action } from './store';

const { mapGetters } = createNamespacedHelpers('search');

export default {
  name: 'AppliedFilterBadges',

  components: {
    FontAwesomeIcon,
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters(['filterGroups', 'searchTerm', 'content']),

    /**
     * @returns {import('./store/state').FacetGroup[]}
     * */
    appliedFilterGroups() {
      /** @type {import('./store/state').FacetGroup[]} */
      const filterGroups = this.filterGroups;

      return filterGroups
        .filter((group) => group.facets.some((f) => f.isSelected))
        .map((group) => ({
          ...group,
          facets: group.facets.filter((f) => f.isSelected),
        }));
    },

    /**
     * @returns {{ faTimes: any }}
     */
    icons() {
      return { faTimes };
    },
  },

  methods: {
    /**
     * @returns {Promise<void>}
     */
    async onSearchTermClick() {
      this.$store.commit(mutation('SET_SEARCH_TERM'), '');

      await this.$store.dispatch(action('LOAD_SEARCH_RESULTS'));
    },

    /**
     * @returns {Promise<void>}
     */
    async onFilterClick(groupId, filterId) {
      this.$store.commit(mutation('TOGGLE_SELECTED_FILTER'), {
        groupId,
        filterId,
      });

      await this.$store.dispatch(action('LOAD_SEARCH_RESULTS'));
    },
  },
};
</script>
